import { capitalizeIfLower } from '@btime/helpers'
import React from 'react'

import { useColors } from '../../../../../packages/kiti/components/theme/_hooks/colors'
import { useGroupedEventsByReason } from './_load/GroupedEventsByReasonLoader'
import PieChart from '../../../../../packages/kiti-charts/components/charts/PieChart'

const GroupedEventsChart = ({ widget }) => {
  const data = useGroupedEventsByReason()?.map(item => ({ ...item, name: capitalizeIfLower(item.name) }))
  const colors = useColors()

  const config = {
    data,
    angleField: 'count',
    colorField: 'name',
    theme: {
      colors10: [
        colors.lightBlue,
        colors.lightCyan,
        colors.dark2,
        colors.lightRed,
        colors.lightPurple,
        colors.lightCyan
      ]
    }
  }
  return <PieChart {...config} />
}

export default GroupedEventsChart
